import React, { useEffect, useState } from "react";
import style from "../aj.module.css";

const patients = {
      "john-doe": {
        name: "John Doe", age: 52, sex: "M", mrn: "001245",
        summary: `
                A 32-year-old man admits himself to the emergency department stating he is "worried it will happen again". His clothes and face are covered in a reddish-brown liquid substance that appears to be blood. Vitals are within normal limits and a chest x-ray and head x-ray are normal. There are no signs of trauma on the head, neck, torso, or extremities. The substance is sent to the lab for further testing.

                On examination, the patient is alert but agitated, with pressured speech and paranoid ideation. Intermittent in his speech are growls and snarls, and the patient asks for windows to see the moon. The patient denies attempts to give him food despite his stated hunger, claiming he only eats "fresh kill".
                
                Laboratory tests are unremarkable. Substance testing reveals nucleated RBCs.
                `,
        meds: ["olanzapine 20mg, unfilled"],
        labs: [["CBC", "Normal", "-"], ["BMP", "Normal", "-"]]
      },
      "matthew-smith": {
        name: "Matthew Smith", age: 41, sex: "M", mrn: "001246",
        summary: `
                A 41-year-old male software engineer presents to the emergency department after sustaining a crush injury to his left leg from a hydraulic press in his garage. He is alert, cooperative, and expresses no remorse or distress about the injury. Orthopedic surgery is consulted, and psychiatry is involved for further assessment. He denies psychosis, suicidal ideation, or depressive symptoms, and his mental status exam is otherwise unremarkable. 
                
                Past psychiatric evaluations have ruled out delusional disorder and gender dysphoria. Previous medical notes show consultation for elective amputation from multiple surgeons.
                `,
        meds: ["None"],
        labs: [["Hct", "33", "42 - 52"], ["Leg X-ray", "Multiple open fractures of femur, tibia, and talus", "-"]]
      },
      "lisa-cho": {
        name: "Lisa Cho", age: 29, sex: "F", mrn: "001247",
        summary: `
                A 29-year old woman is brought to the emergency department by EMS after collapsing during a Botticelli exhibition in the Art Museum. Witnesses reported she became pale and unsteady while viewing the Birth of Venus, then sat down abruptly, clutching her chest. She is diaphoretic, tachycardic (HR 112), and mildly hypotensive (BP 94/58) on arrival.She denies chest pain but describes a "rushing sensation" in her ears, diplopia, and the feeling of being "overwhelmed by beauty". 
                
                She denies prior psychiatric history, drug use, or prior medical conditions. ECG and troponins are normal, tox screen is negative. Neurologic exam is non-focal, and CT head is unremarkable.\n

                She is oriented but intermittently tearful and unable to articulate her emotional state. She has not been sleeping well and has skipped meals. Her affect is labile, alternating between awe and confusion.
                `,
        meds: ["Brevicon QD"],
        labs: [["Troponins", "7.8%", "< 5.7%"], ["Creatinine", "1.1 mg/dL", "0.7–1.3"]]
      },
      "jeremy-coppers": {
        name: "Jeremy Coppers", age: 58, sex: "M", mrn: "001248",
        summary: `
            58-year-old man is brought in by his wife due to escalating paranoia and social withdrawal. He insists she and their daughter have been replaced by identical imposters, citing subtle differences in their behavior and eye movements. He avoids them, has installed interior locks, and obsessively checks mirrors, claiming his reflection “feels off.” He denies hallucinations but admits to feeling “watched” and “unsettled.”

            Six months prior, he sustained a mild head injury from a fall. Since then, he has gotten lost in familiar places and misidentified neighbors. Neurologic exam is normal; MMSE is 27/30 with mild visuospatial deficits. MRI shows right temporal and parietal atrophy. 
            
            Labs and EEG are unremarkable.
        `,
        meds: ["Guaifenesin 600mg q12h PRN"],
        labs: [["MRI", "Normal", "—"], ["EEG", "Unremarkable", "—"]]
      },
      "tom-nguyen": {
        name: "Tom Nguyen", age: 72, sex: "M", mrn: "001249",
        summary: `
            72 y/o male with history of HTN and hyperlipidemia presents to the ED via private vehicle after acute onset of involuntary, uncommanded movements of the left upper extremity (LUE). Symptoms began approximately 3 hours prior while the patient was reading. He states his L hand suddenly closed the book and started attempting to unbutton his shirt while he was simultaneously trying to re-button it with his R hand. 
           
            Actions are described as seemingly purposeful but entirely foreign and outside of conscious control. Patient denies weakness, numbness, pain, visual changes, or other focal neurological deficits. No history of seizure.        
        `,
        meds: ["None"],
        labs: [["CBC", "Normal", "—"], ["Lipid Panel", "Borderline LDL", "LDL < 130 mg/dL"]]
      },
      "sofia-hernandez": {
        name: "Sofia Hernandez", age: 58, sex: "F", mrn: "001250",
        summary:`
            81 y/o female brought in by EMS and police after an intervention triggered by concerned neighbors reporting persistent odors and lack of contact. Patient resides alone. Home environment described by EMS as "severe squalor, floor-to-ceiling trash accumulation, feces, and pest infestation."

            Patient was found on the floor in the living room, in wet, soiled clothing, unable to stand. The estimated time on the floor is unknown, but neighbors last saw her three days ago. Patient is largely apathetic and hostile toward examination, repeatedly stating, "I'm fine. This is my house. Leave me alone." She denies all complaints of pain, shortness of breath, or fever. No reliable historian or collateral information is available. Last known medical contact was approximately 10 years ago.
         `,
        meds: ["Amlodipine 10mg daily", "Hydrochlorothiazide 12.5mg daily"],
        labs: [["BMP", "Normal", "—"], ["Electrolytes", "Normal", "—"]]
      },
      "naomi-williams": {
        name: "Naomi Williams", age: 28, sex: "F", mrn: "001251",
        summary: `
            Patient has a 6-month history of developing delusion directed toward "Sarah M.", a classmate she had one group project with. Patient believes Sarah is her "soul mate" and is sending her telepathic messages and specific signs that they must be together, immediately. The patient reports that Sarah signaled her love by wearing a certain brand of sneakers and "adjusting her glasses in Morse code."
          
            The behavior escalated over the last two weeks: Patient began leaving increasingly personal letters and gifts (including locks of her own hair) taped to the Target's door. The Target called campus police when the patient arrived yesterday morning, refusing to leave, stating, "She told me she'd meet me here: 'We're going to elope.'"
            
            Patient states she has not slept well for three months, feeling "too excited" to rest, and has lost 15 lbs because she's "too connected to food anymore." She denies substance use but admits to hearing "whispers of encouragement" from the walls telling her she is "destined for greatness." When the delusion is challenged, she becomes hostile and paranoid, claiming the examiner is part of an organized effort to keep her and Sarah apart.
            
            This is her first psychiatric hospitalization. Patient reports declining academic performance and increasing social withdrawal over the last year.
            
            Mental Status Exam (MSE):
            Appearance: Unkempt, clothing wrinkled. Mildly disheveled hair.
            Behavior: Agitated, pacing. Maintains rigid eye contact.
            Speech: Loud, rapid, and pressured, frequently veering into grandiose themes (e.g., her superior destiny, her unique telepathic connection).
            Mood: Euthymic to Elevated.
            Affect: Labile, shifting from overly excited when discussing Sarah to suspicious and fearful when asked about treatment.
            Thought Process: Tangential, flight of ideas noted. Disorganized when attempting to provide complex narratives.
            Thought Content: Endorses grandiose delusions (special destiny) and paranoid ideation (conspiracy against her relationship).
            Perceptions: Endorses Auditory Hallucinations (encouraging whispers).
            Cognition: Alert and oriented x 3, but attention is severely limited by agitation.
            Insight/Judgment: Non-existent. Believes hospitalization is a kidnapping. Judgment is grossly impaired, evidenced by the escalating and illegal behavior.
        `,
        meds: ["Doxycycline 100mg daily", "Tretinoin 0.025% cream nightly"],
        labs: [["LFTs", "Normal", "—"]]
      },
      
    };

export default function PatientFile({
  patientId,
  diagnosisStatus,
  diagnosis,
  onBack
}) {

  const [patient, setPatient] = useState(null);

  useEffect(() => {
    if (patientId && patients[patientId]) {
      setPatient(patients[patientId]);
    }
  }, [patientId]);

  if (!patient) {
    return (
      <div className={`${style.ajBody} ${style.patientScreen}`}>
        <p>Patient not found.</p>
        <button className={style.ajButton} onClick={onBack}>← Back to Dashboard</button>
      </div>
    );
  }

  return (
    <div className={`${style.ajBody} ${style.patientScreen}`}>
      <header className={style.ajHeader}>
        <h1 className={style.ajHeaderH1}>Patient Summary</h1>
        <button className={style.ajButton} onClick={onBack}>← Back to Dashboard</button>
      </header>

      <div className={style.patientSummary}>
        <section>
          <h2>Demographics</h2>
          <p><strong>Name:</strong> {patient.name}</p>
          <p><strong>Age:</strong> {patient.age}</p>
          <p><strong>Sex:</strong> {patient.sex}</p>
          <p><strong>MRN:</strong> {patient.mrn}</p>
        </section>

        <section>
          <h2>Visit Summary</h2>
          <p>{patient.summary}</p>
        </section>

        <section>
          <h2>Current Medications</h2>
          <ul>
            {patient.meds.map((med, idx) => <li key={idx}>{med}</li>)}
          </ul>
        </section>

        <section>
          <h2>Recent Labs</h2>
          <table>
            <thead>
              <tr>
                <th>Test</th>
                <th>Result</th>
                <th>Normal Range</th>
              </tr>
            </thead>
            <tbody>
              {patient.labs.map((row, idx) => (
                <tr key={idx}>
                  <td>{row[0]}</td>
                  <td>{row[1]}</td>
                  <td>{row[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section id="diagnosis-status">
          <h2>Diagnosis Status</h2>
          <p>
            Status:{" "}
            <span
              className={
                diagnosisStatus === "Diagnosis correct"
                  ? `${style.statusCorrect}`
                  : `${style.statusIncorrect}`
              }
            >
              {diagnosisStatus}
            </span>
          </p>

          {diagnosisStatus === "Diagnosis correct" && (
            <p>
              <strong>Final Diagnosis:</strong> {diagnosis}
            </p>
          )}
        </section>

      </div>
    </div>
  );
}
